export default __webpack_public_path__ + "static/media/youtube.68054c2f.svg";